module.exports = __webpack_public_path__ + "static/img/default.356e8c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/default.png
// module id = Q0f7
// module chunks = 0